import * as tslib_1 from "tslib";
import { HttpClient, HttpHeaders } from "@angular/common/http";
import { BehaviorSubject } from "rxjs";
import { LeadNote } from '../../model/leadnote.model';
import { getCurrentLocale } from '../lang.storage';
import { environment } from '../../../environments/environment';
var DataService = /** @class */ (function () {
    function DataService(http) {
        this.http = http;
        this.token = new BehaviorSubject("");
        this.jwt = new BehaviorSubject("");
        this.userId = new BehaviorSubject(null);
        this.baseUrl = environment.baseUrlV1;
    }
    Object.defineProperty(DataService.prototype, "locale", {
        get: function () {
            return getCurrentLocale();
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(DataService.prototype, "headers", {
        get: function () {
            var headers = new HttpHeaders({
                "X-LOCALE": this.locale,
            });
            if (this.jwt.value) {
                headers = headers.set("Authorization", "Bearer " + this.jwt.value);
            }
            else if (this.token.value) {
                headers = headers.set("X-COMPANY-TOKEN", this.token.value);
            }
            if (!this.jwt.value && this.userId.value !== null && this.userId.value > 0) {
                headers = headers.set("X-USER-ID", this.userId.value.toString());
            }
            return headers;
        },
        enumerable: true,
        configurable: true
    });
    ;
    // by lead token (BLT)
    DataService.prototype.blt_getLead = function (token, locale) {
        return this.blt_sendRequest("GET", "lead/getByToken", null, token, locale);
    };
    DataService.prototype.blt_getLeadPrices = function (token) {
        return this.blt_sendRequest("GET", "lead/getLeadPrices", null, token);
    };
    DataService.prototype.blt_getLeadNotes = function (token) {
        return this.blt_sendRequest("GET", "notes/getNotes", null, token);
    };
    DataService.prototype.blt_addLeadNote = function (token, note) {
        return this.blt_sendRequest("PUT", "notes/addNote", note, token);
    };
    DataService.prototype.blt_updateLeadFollowup = function (token, followUp) {
        return this.blt_sendRequest("PATCH", "lead/setFollowup", { followUp: followUp }, token);
    };
    DataService.prototype.blt_updateLead = function (token, lead) {
        return this.blt_sendRequest("POST", "lead/setByToken", lead, token);
    };
    DataService.prototype.blt_updateLeadStatus = function (token, statusId) {
        return this.blt_sendRequest("PATCH", "lead/setStatus", { leadStatusId: statusId }, token);
    };
    DataService.prototype.blt_updateLeadSubstatus = function (token, substatusId) {
        return this.blt_sendRequest("PATCH", "lead/setSubstatus", { clientStatusId: substatusId }, token);
    };
    DataService.prototype.blt_updateLeadDealAmount = function (token, amount) {
        return this.blt_sendRequest("PATCH", "lead/setDealAmount", { dealAmount: amount }, token);
    };
    DataService.prototype.blt_getAssignees = function (token) {
        return this.blt_sendRequest("GET", "assignees/getAssignees", null, token);
    };
    DataService.prototype.blt_getProcesses = function (token, locale) {
        return this.blt_sendRequest("GET", "processes/GetProcessesStatusesSubStatuses", null, token, locale);
    };
    DataService.prototype.blt_getPaymentIframe = function (token, locale, login) {
        return this.blt_sendRequest("POST", "payment/requestPaymentIframe", { login: login }, token, locale);
    };
    DataService.prototype.blt_addUserBySms = function (token, smsCode, login, locale) {
        return this.sendRequest("PUT", "users/createUserBySms", { smsCode: smsCode, login: login }, { headers: new HttpHeaders({ "X-LEAD-TOKEN": token, "X-LOCALE": locale }), observe: "response" });
    };
    DataService.prototype.blt_sendRequest = function (verb, url, body, token, locale) {
        if (locale === void 0) { locale = null; }
        var headers = new HttpHeaders();
        if (token)
            headers = headers.set("X-LEAD-TOKEN", token);
        if (locale)
            headers = headers.set("X-LOCALE", locale);
        return this.sendRequest(verb, url, body, { headers: headers });
    };
    // BUT
    // by user token
    // WARNING! SortDirection==0 <=> [old first], SortDirection==1 <=> [new first]
    DataService.prototype.but_getLeads = function (from, q, search, filter, sort, dir) {
        // Only ever called by CallService's automatic, background call-detection lookup — tagged so
        // the HTTP interceptor won't force navigation on a 401 here (see httpconfig.interceptor.ts).
        var headers = this.headers.set('X-Background-Request', 'true');
        return this.sendRequest("POST", "lead/list", { Take: q, Skip: from, Search: search, Filter: filter, Sort: { Member: sort, SortDirection: "" + dir } }, { headers: headers });
    };
    DataService.prototype.but_getAssignees = function () {
        return this.sendRequest("GET", "assignees/getAssignees", null, { headers: this.headers });
    };
    DataService.prototype.but_getProcesses = function (locale) {
        return this.sendRequest("GET", "processes/GetProcessesStatusesSubStatuses", null, { headers: this.headers });
    };
    DataService.prototype.but_getStatuses = function () {
        return this.sendRequest("GET", "processes/GetStatusesSubStatuses", null, { headers: this.headers });
    };
    DataService.prototype.but_createProcess = function (process) {
        return this.sendRequest("POST", "processes/createProcess", process, { headers: this.headers });
    };
    DataService.prototype.but_updateProcess = function (process) {
        return this.sendRequest("POST", "processes/updateProcess", process, { headers: this.headers });
    };
    DataService.prototype.but_deleteProcess = function (process) {
        return this.sendRequest("POST", "processes/deleteProcess", process, { headers: this.headers });
    };
    DataService.prototype.but_getSubstatuses = function () {
        return this.sendRequest("GET", "substatuses/getSubStatuses", null, { headers: this.headers });
    };
    DataService.prototype.but_addSubstatus = function (substatus) {
        return this.sendRequest("PUT", "substatuses/createSubStatus", substatus, { headers: this.headers });
    };
    DataService.prototype.but_updateSubstatus = function (substatus) {
        return this.sendRequest("POST", "substatuses/updateSubStatus", substatus, { headers: this.headers });
    };
    DataService.prototype.but_deleteSubstatus = function (substatus) {
        return this.sendRequest("DELETE", "substatuses/deleteSubStatus", null, { headers: this.headers, body: substatus });
    };
    DataService.prototype.but_getUsers = function () {
        return this.sendRequest("GET", "users/getUsers", null, { headers: this.headers });
    };
    DataService.prototype.but_addUser = function (user, locale) {
        return this.sendRequest("PUT", "users/createUser", user, { headers: this.headers });
    };
    DataService.prototype.but_updateUser = function (user) {
        return this.sendRequest("POST", "users/updateUser", user, { headers: this.headers, observe: "response" });
    };
    DataService.prototype.but_updateUserSettings = function (user) {
        return this.sendRequest("POST", "users/updateUserSettings", user, { headers: this.headers, observe: "response" });
    };
    DataService.prototype.but_deleteUser = function (user, locale) {
        return this.sendRequest("DELETE", "users/deleteUser", null, { headers: this.headers, body: user });
    };
    // universal
    DataService.prototype.getLangs = function () {
        return this.http.get("assets/json/langs.json");
    };
    DataService.prototype.getTemplates = function () {
        return this.http.get("assets/json/templates.json");
    };
    DataService.prototype.authMe = function () {
        return this.sendRequest("GET", "auth/me", null, { headers: this.headers, observe: "response" });
    };
    DataService.prototype.getOidcUrl = function (returnUrl, companyId) {
        var params = [];
        if (returnUrl)
            params.push("returnUrl=" + encodeURIComponent(returnUrl));
        if (companyId)
            params.push("companyId=" + companyId);
        var url = params.length ? "auth/oidc-url?" + params.join('&') : "auth/oidc-url";
        // Request without auth headers since user is not authenticated yet
        // Use this.baseUrl from environment (localhost:5000 for local dev)
        return this.http.get(this.baseUrl + url);
    };
    DataService.prototype.getCurrentVersionFromServer = function () {
        return this.sendRequest2("GET", "info/version", null);
    };
    DataService.prototype.forgotPassword = function (username, locale) {
        return this.sendRequest("POST", "auth/forgotPassword", { "username": "" + username, "Locale": "" + locale }, { observe: "response" });
    };
    // generic request
    DataService.prototype.sendRequest = function (verb, url, body, options) {
        if (options === void 0) { options = {}; }
        var requestOptions = tslib_1.__assign({ withCredentials: !this.jwt.value }, options);
        if (verb === "POST") {
            return this.http.post(this.baseUrl + url, body, requestOptions);
        }
        else if (verb === "PATCH") {
            return this.http.patch(this.baseUrl + url, body, requestOptions);
        }
        else if (verb === "PUT") {
            return this.http.put(this.baseUrl + url, body, requestOptions);
        }
        else if (verb === "DELETE") {
            return this.http.delete(this.baseUrl + url, requestOptions);
        }
        else if (verb === "FILE") {
            var fileUrl = url.startsWith('http://') || url.startsWith('https://') ? url : environment.baseUrl + url;
            return this.http.get(fileUrl, { headers: this.headers, observe: "response", responseType: "arraybuffer", withCredentials: !this.jwt.value });
        }
        else {
            return this.http.get(this.baseUrl + url, requestOptions);
        }
    };
    DataService.prototype.sendRequest2 = function (verb, url, body) {
        if (verb === "POST") {
            return this.http.post(environment.baseUrlV2 + url, body, { headers: this.headers, withCredentials: !this.jwt.value });
        }
        else if (verb === "PATCH") {
            return this.http.patch(environment.baseUrlV2 + url, body, { headers: this.headers, withCredentials: !this.jwt.value });
        }
        else if (verb === "PUT") {
            return this.http.put(environment.baseUrlV2 + url, body, { headers: this.headers, withCredentials: !this.jwt.value });
        }
        else if (verb === "DELETE") {
            return this.http.delete(environment.baseUrlV2 + url, { headers: this.headers, withCredentials: !this.jwt.value });
        }
        else if (verb === "FILE") {
            return this.http.get(environment.baseUrlV2 + url, { headers: this.headers, observe: "response", responseType: "arraybuffer", withCredentials: !this.jwt.value });
        }
        else { // GET
            return this.http.get(environment.baseUrlV2 + url, { headers: this.headers, withCredentials: !this.jwt.value });
        }
    };
    DataService.prototype.sendRequest2WithCrmToken = function (_token, verb, url, body) {
        var headers = this.headers;
        var opts = { headers: headers, withCredentials: !this.jwt.value };
        if (verb === "POST") {
            return this.http.post(environment.baseUrlV2 + url, body, opts);
        }
        else if (verb === "PATCH") {
            return this.http.patch(environment.baseUrlV2 + url, body, opts);
        }
        else if (verb === "PUT") {
            return this.http.put(environment.baseUrlV2 + url, body, opts);
        }
        else if (verb === "DELETE") {
            return this.http.delete(environment.baseUrlV2 + url, opts);
        }
        else if (verb === "FILE") {
            return this.http.get(environment.baseUrlV2 + url, { headers: headers, observe: "response", responseType: "arraybuffer", withCredentials: !this.jwt.value });
        }
        else { // GET
            return this.http.get(environment.baseUrlV2 + url, opts);
        }
    };
    // v2
    DataService.prototype.but_getLeadClients = function (from, q, search, filter, sort, dir, processId) {
        return this.sendRequest2("POST", "leadClient/list", { Take: q, Skip: from, Search: search, Filter: filter, processId: processId, Sort: { Member: sort, SortDirection: "" + dir } });
    };
    DataService.prototype.but_updateLeadClientFollowUp = function (id, followUp) {
        return this.sendRequest2("PATCH", "leadClient/setFollowup", { Id: id, followUp: followUp });
    };
    DataService.prototype.but_updateLeadClientStatus = function (leadClient) {
        // Normalize payload according to API validation rules:
        // - clientStatusId: 0 is not allowed, use null to clear
        // - clientStatusId must be null when clientStageId is Closed (9) or Meeting (7)
        var payload = tslib_1.__assign({}, leadClient);
        if (payload.clientStatusId === 0) {
            console.warn("ClientStatusId cannot be 0. Using null instead to clear the status.");
            payload.clientStatusId = null;
        }
        if (payload.clientStageId === 9 || payload.clientStageId === 7) {
            if (payload.clientStatusId !== null) {
                console.warn("ClientStatusId must be null for ClientStageId " + payload.clientStageId + ". Forcing null.");
            }
            payload.clientStatusId = null;
        }
        return this.sendRequest2("PATCH", "leadClient/setStatus", payload);
    };
    DataService.prototype.but_getLeadClient = function (id) {
        return this.sendRequest2("GET", "leadClient/getByToken?id=" + id, null);
    };
    DataService.prototype.but_addLeadClient = function (client) {
        return this.sendRequest2("POST", "leadClient/create", {
            fullname: client.fullName,
            email: client.email,
            phone: client.phone,
            userId: client.userId,
            clientProcessId: client.clientProcessId,
            clientStageId: client.clientStageId,
            clientStatusId: client.clientStatusId,
            source: client.source,
            address: client.address
        });
    };
    DataService.prototype.but_updateLeadClient = function (client) {
        return this.sendRequest2("PUT", "leadClient/update", {
            clientStatusId: client.clientStatusId,
            address: client.address,
            addressCoords: client.addressCoords,
            userId: client.userId,
            id: client.id,
            email: client.email,
            followUp: client.followUp,
            fullname: client.fullName,
            clientStageId: client.clientStageId,
            phone: client.phone,
            clientProcessId: client.clientProcessId,
            source: client.source,
        });
    };
    DataService.prototype.but_updateLeadClientDeal = function (dealId, clientId, subject, amount, userId, dealDate) {
        return this.sendRequest2("PATCH", "leadClient/setDeals", { dealId: dealId, clientId: clientId, subject: subject, amount: amount, userId: userId, dealDate: dealDate, externalCrmId: 0 });
    };
    DataService.prototype.but_getDealById = function (id) {
        return this.sendRequest2("GET", "leadClient/deal/getById?id=" + id, null);
    };
    DataService.prototype.but_UpdateDeal = function (id, clientId, subject, amount, userId) {
        return this.sendRequest2("PATCH", "leadClient/updateDeal", { id: id, clientId: clientId, subject: subject, amount: amount, userId: userId });
    };
    DataService.prototype.but_LeadClientAddMeeting = function (id, clientId, meetingDate, meetingEndDate, subject, userId, externalId, note, meetingStatus) {
        return this.sendRequest2("PATCH", "leadClient/addMeeting", { id: id, clientId: clientId, meetingDate: meetingDate, meetingEndDate: meetingEndDate, subject: subject, userId: userId, externalId: externalId, note: note, meetingStatus: meetingStatus });
    };
    DataService.prototype.but_LeadClientGetMeeting = function (id) {
        return this.sendRequest2("GET", "leadClient/getMeetingById?id=" + id, null);
    };
    DataService.prototype.but_LeadClientCancelMeeting = function (id, locale) {
        return this.sendRequest2("GET", "leadClient/cancelMeetingById?id=" + id, null);
    };
    DataService.prototype.but_LeadClientCancelDeal = function (id) {
        return this.sendRequest2("GET", "leadClient/cancelDealById?id=" + id, null);
    };
    DataService.prototype.but_LeadClientUpdateMeeting = function (id, clientId, meetingDate, meetingEndDate, subject, userId, externalId, note, meetingStatus) {
        return this.sendRequest2("PATCH", "leadClient/updateMeeting", { id: id, clientId: clientId, meetingDate: meetingDate, meetingEndDate: meetingEndDate, subject: subject, userId: userId, externalId: externalId, note: note, meetingStatus: meetingStatus });
    };
    DataService.prototype.but_getLeadClientNotes = function (id) {
        return this.sendRequest2("GET", "leadClient/getNotes?id=" + id, null);
    };
    DataService.prototype.but_addLeadClientNote = function (clientId, note, userId, gpsLongitude, gpsLatitude, createdDate) {
        return this.sendRequest2("POST", "leadClient/createNote", { clientId: clientId, note: note, userId: userId, gpsLongitude: gpsLongitude, gpsLatitude: gpsLatitude, createdDate: createdDate });
    };
    DataService.prototype.but_getLeadNotes = function (leadId) {
        return this.sendRequest2("GET", "lead/getNotes?leadId=" + leadId, null);
    };
    DataService.prototype.but_addLeadNote = function (leadId, note, userId, gpsLongitude, gpsLatitude, createdDate) {
        var leadNote = new LeadNote();
        leadNote.userId = userId;
        leadNote.leadId = leadId;
        leadNote.content = note;
        leadNote.createDate = createdDate;
        leadNote.gpsLatitude = gpsLatitude;
        leadNote.gpsLongitude = gpsLongitude;
        return this.sendRequest2("POST", "lead/createLeadNote", leadNote);
    };
    DataService.prototype.but_setPositionToSubstatus = function (substatus, isUp) {
        return this.sendRequest2("PATCH", "substatus/setPositionToSubstatus", { Id: substatus.id, isUp: isUp });
    };
    DataService.prototype.but_getLeadsForLeadClient = function (id) {
        return this.sendRequest2("GET", "leadClient/leads?id=" + id, null);
    };
    DataService.prototype.but_getLead = function (leadId) {
        return this.sendRequest2("GET", "lead?leadId=" + leadId, null);
    };
    DataService.prototype.but_getDealsForLeadClient = function (id) {
        return this.sendRequest2("GET", "leadClient/deals?id=" + id, null);
    };
    DataService.prototype.but_getMeetingsForLeadClient = function (id) {
        return this.sendRequest2("GET", "leadClient/meetings?id=" + id, null);
    };
    DataService.prototype.but_getAdPreview = function (channelId, adGroupId, adId) {
        return this.sendRequest2("GET", "adpreview?channelId=" + channelId + "&adGroupId=" + adGroupId + "&adId=" + adId, null);
    };
    //#region SignalR
    DataService.prototype.getAllWhatsappMessagesLeadClient = function (clientId, phone) {
        var url = "leadClient/getAllMessages?id=" + clientId;
        if (phone) {
            url += "&phone=" + encodeURIComponent(phone);
        }
        return this.sendRequest2("GET", url, null);
    };
    DataService.prototype.getFile = function (url) {
        return this.convertFileResponseToBlob(this.sendRequest("FILE", url, null));
    };
    DataService.prototype.getMessageFile = function (url) {
        return this.convertFileResponseToBlob(this.sendRequest2("FILE", url, null));
    };
    DataService.prototype.getTemplatesForLeadClient = function (clientId, phone) {
        var url = "leadClient/templates?id=" + clientId;
        if (phone) {
            url += "&phone=" + encodeURIComponent(phone);
        }
        return this.sendRequest2("GET", url, null);
    };
    DataService.prototype.markMessagesAsRead = function (clientId) {
        return this.sendRequest2("POST", "leadClient/markMessagesAsRead", { clientId: clientId });
    };
    DataService.prototype.sendReplyWhatsappMessage = function (clientId, message, userId, whatsappPhone) {
        return this.sendRequest2("PUT", "leadClient/sendReplyMessage", { "clientId": "" + clientId, "message": "" + message, "userId": "" + userId, "whatsappPhone": "" + whatsappPhone });
    };
    DataService.prototype.sendReplyWhatsappFile = function (clientId, userId, files, whatsappPhone) {
        var formData = new FormData();
        formData.append('clientId', clientId.toString());
        formData.append('userId', userId.toString());
        if (whatsappPhone) {
            formData.append("whatsappPhone", whatsappPhone);
        }
        if (files && files.length > 0) {
            for (var i = 0; i < files.length; i++) {
                formData.append('files', files[i], files[i].name);
            }
        }
        return this.sendRequest2("POST", "leadClient/sendReplyFile", formData);
    };
    DataService.prototype.sendTemplateWhatsappMessage = function (clientId, templateName, userId, whatsappPhone) {
        return this.sendRequest2("PUT", "leadClient/sendTemplateMessage", { "clientId": "" + clientId, "templateName": "" + templateName, "userId": "" + userId, "whatsappPhone": "" + whatsappPhone });
    };
    DataService.prototype.getLeadClient = function (phone) {
        return this.sendRequest2("GET", "leadClient/getByPhone?phone=" + phone, null);
    };
    DataService.prototype.getLeadClientByEmail = function (email) {
        return this.sendRequest2("GET", "leadClient/getByEmail?email=" + email, null);
    };
    DataService.prototype.updateLeadClientAddress = function (clientId, address, addressCoords) {
        return this.sendRequest2("PUT", "leadClient/updateAddress", { "clientId": "" + clientId, "address": address, "addressCoords": addressCoords });
    };
    //#region WithCrmToken
    DataService.prototype.getAllWhatsappMessagesLeadClientWithCrmToken = function (token, clientId, phone) {
        var url = "leadClient/getAllMessages?id=" + clientId;
        if (phone) {
            url += "&phone=" + encodeURIComponent(phone);
        }
        return this.sendRequest2WithCrmToken(token, "GET", url, null);
    };
    DataService.prototype.getMessageFileWithCrmToken = function (token, url) {
        return this.convertFileResponseToBlob(this.sendRequest2WithCrmToken(token, "FILE", url, null));
    };
    DataService.prototype.getLeadClientWithCrmToken = function (token, id) {
        return this.sendRequest2WithCrmToken(token, "GET", "leadClient/getByCrmToken?clientId=" + id, null);
    };
    DataService.prototype.getTemplatesForLeadClientWithCrmToken = function (token, clientId, phone) {
        var url = "leadClient/templates?id=" + clientId;
        if (phone) {
            url += "&phone=" + encodeURIComponent(phone);
        }
        return this.sendRequest2WithCrmToken(token, "GET", url, null);
    };
    DataService.prototype.markMessagesAsReadWithCrmToken = function (token, clientId) {
        return this.sendRequest2WithCrmToken(token, "POST", "leadClient/markMessagesAsRead", { clientId: clientId });
    };
    DataService.prototype.sendReplyWhatsappMessageWithCrmToken = function (token, clientId, message, userId, whatsappPhone) {
        return this.sendRequest2WithCrmToken(token, "PUT", "leadClient/sendReplyMessage", { "clientId": "" + clientId, "message": "" + message, "userId": "" + userId, "whatsappPhone": "" + whatsappPhone });
    };
    DataService.prototype.sendReplyWhatsappFileMessageWithCrmToken = function (token, clientId, message, userId, files, whatsappPhone) {
        var formData = new FormData();
        formData.append("clientId", clientId.toString());
        formData.append("userId", userId.toString());
        if (whatsappPhone) {
            formData.append("whatsappPhone", whatsappPhone);
        }
        for (var i = 0; i < files.length; i++) {
            formData.append('files', files[i], files[i].name);
        }
        return this.sendRequest2WithCrmToken(token, "POST", "leadClient/sendReplyFile", formData);
    };
    DataService.prototype.sendTemplateWhatsappMessageWithCrmToken = function (token, clientId, templateName, userId, whatsappPhone) {
        return this.sendRequest2WithCrmToken(token, "PUT", "leadClient/sendTemplateMessage", { "clientId": "" + clientId, "templateName": "" + templateName, "userId": "" + userId, "whatsappPhone": "" + whatsappPhone });
    };
    DataService.prototype.but_getAdPreviewWithCrmToken = function (token, channelId, adGroupId, adId) {
        return this.sendRequest2WithCrmToken(token, "GET", "adpreview?channelId=" + channelId + "&adGroupId=" + adGroupId + "&adId=" + adId, null);
    };
    //#endregion WithCrmToken
    DataService.prototype.convertFileResponseToBlob = function (response) {
        return new Promise(function (resolve, reject) {
            response.toPromise().then(function (response) {
                var contentType = response.headers.get("Content-Type");
                if (contentType.startsWith('application/json')) {
                    var decoder = new TextDecoder("utf-8");
                    var resp = JSON.parse(decoder.decode(new Uint8Array(response.body)));
                    reject(resp);
                }
                else {
                    var blob = new Blob([response.body], { type: contentType });
                    resolve(blob);
                }
            }).catch(reject);
        });
    };
    return DataService;
}());
export { DataService };
